import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "login-page" }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = { class: "admin-white-bg admin-custom-row" }
const _hoisted_5 = { class: "admin-login-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "admin-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Admin Logo"
  })
], -1)
const _hoisted_7 = { class: "admin-login-form" }
const _hoisted_8 = { class: "login-input" }
const _hoisted_9 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_10 = {
  id: "forgotPwtSubmitBtn",
  type: "submit",
  class: "primary-btn"
}
const _hoisted_11 = { class: "admin-login-right" }
const _hoisted_12 = { class: "admin-login-right-in" }
const _hoisted_13 = { class: "admin-site-footer" }
const _hoisted_14 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h1", null, _toDisplayString(_ctx.constants.FORGOT_PASSWORD_TEXT), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("form", {
                id: "forgotPwtForm",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "forgotPwtEmailInput",
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    placeholder: "Enter Email address"
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ]),
                  (!_ctx.email||_ctx.errorMsg==='Email not registered.')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMsg), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.constants.SEND_EMAIL_BUTTON), 1)
              ], 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.constants.FORGOT_PASSWORD_TEXT), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.constants.ENTER_THE_EMAIL_ASSOCIATED_WITH_YOUR_ACCOUNT_AND_WE_LL_SEND_AN_EMAIL_WITH_INSTRUCTIONS_TO_RESET_YOUR_PASSWORD_TEXT), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ])
  ]))
}